export const API_BASE = ((import.meta.env.VITE_API_URL as string | undefined) ?? "http://localhost:3001").replace(/\/$/, "");

export class ApiError extends Error {
  constructor(public status: number, message: string, public data: Record<string, unknown> = {}) {
    super(message);
  }
}

/** A call with no sign-in (the customer's payment page). Display calls use displayApi instead. */
export async function api<T>(path: string, opts: { method?: string; body?: unknown } = {}): Promise<T> {
  const res = await fetch(API_BASE + path, {
    method: opts.method ?? (opts.body !== undefined ? "POST" : "GET"),
    headers: { Accept: "application/json", ...(opts.body !== undefined ? { "Content-Type": "application/json" } : {}) },
    body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined,
    credentials: "omit",
  });
  const data = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (!res.ok) throw new ApiError(res.status, (data.error as string) || `Request failed (${res.status})`, data);
  return data as T;
}

export const till = (p: string) => `/api/v1/till${p}`;

/** Store identity from the public storefront endpoint: name, logo, currency. Kept for offline starts. */
export type Storefront = { storeName: string; packId: string | null; settings?: { logo?: string }; currency?: { code: string; symbol: string } };
export async function loadStorefront(): Promise<Storefront | null> {
  const KEY = "display.storefront";
  try {
    const res = await fetch(`${API_BASE}/api/v1/storefront`, { credentials: "omit" });
    if (!res.ok) return null;
    const sf = (await res.json()) as Storefront;
    try {
      localStorage.setItem(KEY, JSON.stringify({ storeName: sf.storeName, packId: sf.packId, settings: { logo: sf.settings?.logo }, currency: sf.currency }));
    } catch {
      /* full */
    }
    return sf;
  } catch {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "null") as Storefront | null;
    } catch {
      return null;
    }
  }
}
